import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CertificatesService } from 'src/app/services/certificates.service'
import { ToastrService } from 'ngx-toastr'
import Swal from 'sweetalert2';
@Component({
  selector: 'app-add-certificate',
  templateUrl: './add-certificate.component.html',
  styleUrls: ['./add-certificate.component.css']
})
export class AddCertificateComponent implements OnInit {
  private fileContent: any;
  private id: any = -1;
  private isError: any;
  private fileUploadQueue: any;
  files: File[] = [];

  onSelect(event) {
    console.log(event);
    this.files = [];
    this.files.push(...event.addedFiles);
    this.handleFileInput(this.files);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }
  @Output() messageEvent = new EventEmitter<string>();
  constructor(private certificateService: CertificatesService, private toastrService: ToastrService) { }

  ngOnInit() {
    localStorage.setItem('option', 'certificate');
    this.certificateService.getCertificate().subscribe((res) => {
      if (res['data'])
        this.id = res['_id'];
    }, error => {
      alert(error);
    })
  }

  submit() {
    if (this.fileContent == undefined)
      this.isError = true;
    else {

      Swal({
        title: 'This will overwrite previous contents?',
        text: "",
        type: 'warning',
        width: '30%',
        showCancelButton: true,
        confirmButtonColor: 'text-danger',
       cancelButtonColor: '#f8ac59',
        confirmButtonText: 'Yes, continue!'
      }).then((result) => {
        if (result.value) {
          this.id=localStorage.getItem("org_id");
          this.certificateService.loadCertificate(this.id, this.fileContent).subscribe((res) => {
            if (res['success']) {

              this.toastrService.success(res['message']);
              this.isError = false;
              this.sendContentsToParent();
            }
          })
        }
      })

    }
  }


  handleFileInput(files: any) {
    this.getFileText(files[0], (result) => {
      this.fileContent = result;
    },
      function (error) {
        console.log('Error: ', error);
      }
    )
  }
  getFileText(file, success, error) {
    var reader = new FileReader();
    reader.readAsText(file);
    reader.onerror = error;
    reader.onload = () => {
      success(reader.result)
    };
  }

  sendContentsToParent() {

    this.messageEvent.emit(this.fileContent);
  }

  onFileComplete($event) {

  }
}
